module.exports = __webpack_public_path__ + "img/flex5_3_Extended-menu-desktop.8e6699fa.png";